module.exports = __webpack_public_path__ + "static/media/jest.02775579.jpg";